

















import { Component, Vue } from 'vue-property-decorator'
import Site, { SiteDetail } from '../common/Site'
import t from '../i18n'

@Component
export default class ActivatePage extends Vue {
  t = t
  Site = Site

  isActive = true

  private async created () {
    document.body.classList.add('register-page')
    document.title = Site.isPPBrand ? t('Position Partners SSO') : t('Aptella SSO')
    this.isActive = SiteDetail.getCookieMap().get('code_status') === 'valid'
  }

  private login () {
    window.location.pathname = '/signin'
  }
}
